import { Platform } from 'react-native';

// On native, always use full URL. On web, use /api proxy in dev, direct URL in prod.
// @ts-ignore – __DEV__ is defined by both Metro (native) and Vite (via define config)
const isDev = typeof __DEV__ !== 'undefined' ? __DEV__ : false;
const API_BASE = Platform.OS !== 'web'
  ? 'https://api.guidedverses.xyz'
  : (isDev ? '/api' : '//api.guidedverses.xyz');

export async function fetchChapters() {
  const res = await fetch(`${API_BASE}/chapter_headers`);
  const data = await res.json();
  return data.result;
}

export async function fetchAvailableTranslations() {
  const res = await fetch(`${API_BASE}/available_translations`);
  const data = await res.json();
  return data.result;
}

export async function fetchVerses(ch: string | number, vs: string, ln: string) {
  const res = await fetch(`${API_BASE}/verse?ch=${ch}&vs=${vs}&ln=${ln}`);
  const data = await res.json();
  return data.result;
}

export async function fetchReciters() {
  const res = await fetch(`${API_BASE}/available_recitation_sources`);
  const data = await res.json();
  return data.result;
}
